import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import axios from "axios";


import api from '../../../api/';
import auth from '../../../auth/';
var getUrl = api.proyectos.config.plan.campos.select;
import Create from "./Create.js"

import { Input, Row, Col } from 'reactstrap';

class CamposSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: '',
			pk: 0,
			options: []
		};
	}

	static propTypes = {
		label: PropTypes.string,
		onChange: PropTypes.func,
		value: PropTypes.any,
		Create: PropTypes.bool,
		disabled: PropTypes.bool,
		excluded: PropTypes.any
	}

	onChange(value) {
		var pk = (value ? value.pk : 0);
		this.setState({
			value: value,
			pk: pk,
		});
		if (this.props.onChange) this.props.onChange(value);
	}

	resetState() {
		this.setState({
			value: this.props.value,
			pk: this.props.value.pk
		});
	}


	componentWillReceiveProps(nextProps) {
		this.setState({
			value: this.getOption(nextProps.value),
			pk: nextProps.value
		});
	}


	getOptions = (input, callback) => {
		axios.get(getUrl, auth.header())
			.then((response) => {
				let opts = response.data.rows;

				if (this.props.excluded) {
					opts = opts.filter(x => this.props.excluded.indexOf(x.pk) == -1);
				}

				this.setState({ options: opts });
				callback(null,
					{
						options: opts,
						complete: true
					});
				if (this.props.value)
					setTimeout(() => this.resetState(), 10);
			});
	};

	getOption(value) {
		for (var i = 0; i < this.state.options.length; i++) {
			if (this.state.options[i].pk == value)
				return this.state.options[i];
		}
	}

	Created(value) {
		this.getOptions("", (res) => {
			this.setState({
				value: this.getOption(value.pk),
				pk: value.pk
			});
		});
	}

	render() {
		if (this.props.Create)
			return (
				<Row>
					<Input
						name="campo_id"
						value={this.state.pk}
						onChange={(e) => {}}
						className="d-none"
						type="number" />
					<Col className="col-10">
						<Select.Async
							multi={false}
							backspaceRemoves={true}
							value={this.state.value}
							onChange={(value) => this.onChange(value)}
							valueKey="pk"
							labelKey="nombre"
							loadOptions={this.getOptions} />
					</Col>
					<Col className="col-2">
						<Create label={"Nueva"} onSubmit={(value) => this.Created(value)} />
					</Col>
				</Row>
			);
		else
			return (
				<div>
					<Input
						name="campo_id"
						value={this.state.pk}
						onChange={(e) => {}}
						className="d-none"
						type="number" disabled={this.props.disabled} />
					<Input
						name="campo_nombre"
						value={this.state.value.nombre}
						onChange={(e) => {}}
						className="d-none"
						type="text" disabled={this.props.disabled} />
					<Select.Async
						multi={false}
						backspaceRemoves={true}
						value={this.state.value}
						onChange={(value) => this.onChange(value)}
						valueKey="pk"
						labelKey="nombre"
						loadOptions={this.getOptions} disabled={this.props.disabled} />
				</div>
			);
	}
};

module.exports = CamposSelect;


// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/CamposSelect.js